import { render, staticRenderFns } from "./user_management.vue?vue&type=template&id=5ff38c86&"
import script from "./user_management.vue?vue&type=script&lang=js&"
export * from "./user_management.vue?vue&type=script&lang=js&"
import style0 from "./user_management.vue?vue&type=style&index=0&id=5ff38c86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports